import { render, staticRenderFns } from "./SupplierCreateView.vue?vue&type=template&id=76c5aed1"
import script from "./SupplierCreateView.vue?vue&type=script&lang=js"
export * from "./SupplierCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports